import { Column } from '@tanstack/react-table'
import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react'

import { Button } from '@/ui/atoms/button/Button'
import { cn } from '@/ui/utils/style'

import { ColumnDefinition } from '../types'

interface ColumnHeaderProps<T> {
  column: Column<T>
  columnDefinition: ColumnDefinition<T> | undefined
}

export function ColumnHeader<T>({ column, columnDefinition }: ColumnHeaderProps<T>) {
  const { headerAlign, sortable, header } = columnDefinition ?? {}
  const isSorted = column.getIsSorted()
  const isActive = isSorted !== false

  return (
    <div
      className={cn(
        'flex flex-row',
        headerAlign === 'center' && 'justify-center',
        headerAlign === 'right' && 'justify-end',
      )}
    >
      <Button
        variant="text"
        className={cn(
          'h-4 cursor-auto p-0 font-bold text-xs transition-colors',
          sortable && 'cursor-pointer hover:text-white',
          isActive
            ? 'bg-gradient-to-r from-gradient-yellow to-gradient-green bg-clip-text text-transparent'
            : 'text-neutral-400',
        )}
        onClick={() => sortable && column.toggleSorting(isSorted === 'asc')}
        postfixIcon={
          sortable &&
          (isActive ? (
            isSorted === 'asc' ? (
              <ArrowDown className="text-white" size={14} />
            ) : (
              <ArrowUp className="text-white" size={14} />
            )
          ) : (
            <ChevronsUpDown className="text-neutral-500" size={14} />
          ))
        }
      >
        {header}
      </Button>
    </div>
  )
}
